// src/components/heroManagementDashboard/registration/steps/StepWelcome.jsx
import React, { useEffect, useState } from "react";
import MultiStyleButton from "../../systemUtils/MultiStyleButton";
import { extractCompanyName } from "./functions/utilityStepFunctions";
import heroLogo from "../../../../images/heroLogo.png";
import "../RegisterSteps.css";
import { getAuth } from "firebase/auth";
import { useDispatch } from "react-redux";
import {
  setRegistrationData,
  setRegistrationStep,
} from "../../../../redux/actionsFolder/registrationActions";
import { useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import LoadingCircle from "../../../../components/utils/LoadingCircle";

const StepWelcome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userEmail, setUserEmail] = useState("");
  const [userRole, setUserRole] = useState("");
  const [company, setCompany] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user) {
        try {
          const tokenResult = await user.getIdTokenResult();
          const email = user.email;
          const role = tokenResult.claims.role || "user";
          const derivedCompanyName = extractCompanyName(role);
          if (derivedCompanyName) {
            setUserEmail(email);
            setUserRole(role);
            setCompany(derivedCompanyName);
          } else {
            console.warn("Failed to derive company name from role.");
          }
        } catch (error) {
          console.error("Error fetching user details:", error);
        }
      } else {
        console.warn("No user is currently logged in.");
      }
    };

    fetchUserDetails();
  }, []);

  // Function to check if the company is already configured
  const checkCompanySetup = async (companyName, collectionBrand) => {
    try {
      const functions = getFunctions();
      const firestoreOps = httpsCallable(functions, "firestoreOperations");
      const result = await firestoreOps({
        operation: "read",
        company: companyName.replace(/\s+/g, "_"), // Normalize company name
        collectionBrand: collectionBrand,
        systemName: "companyConfig",
        uniqueId: "configStatus",
      });
      if (
        result.data &&
        result.data.data &&
        result.data.data.isComplete === true
      ) {
        // Company is already set up
        return true;
      }
    } catch (error) {
      console.error("Error checking company setup:", error);
    }
    return false;
  };

  const handleContinue = async () => {
    if (userEmail && company) {
      setIsLoading(true);
      // Set fixed parameters for the registration process
      const collectionBrand = "TechPerformanceCentre";
      const systemName = "companyConfig";

      // Check if the company is already set up
      const alreadySetUp = await checkCompanySetup(company, collectionBrand);
      if (alreadySetUp) {
        // If configuration is complete, navigate to the Hero Dashboard
        navigate("/hero-dashboard");
        return;
      }

      // Otherwise, dispatch the registration data into Redux
      dispatch(
        setRegistrationData({ userEmail, company, collectionBrand, systemName })
      );
      dispatch(setRegistrationStep("welcome"));

      // Navigate to the next step in registration
      navigate("/register-hero/company-setup");
      setIsLoading(false);
    } else {
      console.error("User email or company name is missing. Cannot proceed.");
    }
  };

  if (isLoading) {
    return (
      <div className="step-container step-welcome-container">
        <LoadingCircle />
      </div>
    );
  }

  return (
    <div className="step-container step-welcome-container">
      <div className="step-logo-container">
        <img src={heroLogo} alt="Hero Logo" className="step-logo" />
      </div>
      <h2 className="step-title">Welcome to Hero!</h2>
      <p className="step-description">
        Let's get you set up with your company profile and the systems you wish
        to use.
      </p>
      <p className="step-instruction">
        This is a multi step process, where we will request you to submit
        company documentation. To process the documentation takes about 3
        minutes, so please allow for enough time.
      </p>
      <div className="step-button-container">
        <MultiStyleButton
          label="Continue"
          buttonType="approve"
          onClick={handleContinue}
        />
      </div>
    </div>
  );
};

export default StepWelcome;
